import React, { useEffect, useState } from "react";
import LivePositionsPHK from "./LivePositionsPHK";
import LivePositionsRestAccount from "./LivePositionsRestAccounts";
import LivePositionsCM from "./LivePositionsCM";
import NewLivePositionsRestAccounts from "./NewLivePositionsRestAccounts";
import NewLivePositionsPHK from "./NewLivePositionsPHK";
import NewLivePositionsCM from  "./NewLivePositionsCM";
import LivePositionsWebsocket from "./LivePositionsWebsocket";

export default function LivePositionsTable({
  livePositionsData,
  filteredLivePositionsData,
  setFilteredLivePositionsFno,
  setFilteredLivePositionsEquity,
  sortOrder,
  setSortOrder,
  currentState,
  accountName,
  allUser,
  currentPage,
  setCurrentPage,
  state,
  ...props
}) {
  const [newPositionData, setNewPositionData] = useState();
  const [dpkPositions, setDpkPositions] = useState([]);
  const [phkPositions, setPhkPositions] = useState([]);
  const [otherAccPositions, setOtherAccPositions] = useState([]);

  const [filteredDpkPositions, setFilteredDpkPositions] =
    useState(dpkPositions);
  const [filteredPhkPositions, setFilteredPhkPositions] =
    useState(phkPositions);
  const [filteredOtherAccPositions, setFilteredOtherAccPositions] =
    useState(otherAccPositions);

  const [livePositionTab, setLivePositionsTab] = useState("cm-positions");

  const handleChangeTabs = (tabName) => {
    setLivePositionsTab(tabName);
  };

  // useEffect(() => {

  //   console.log("Live Positions beofre the Data Updated", filteredLivePositionsData);
  //   const newDpkPosition = filteredLivePositionsData.filter((item) =>
  //     item.clientIds.includes("CA00246")
  //   );
  //   const newPhkPosition = filteredLivePositionsData.filter((item) =>
  //     item.clientIds.includes("XP15732")
  //   );
  //   const newOtherAccPositions = filteredLivePositionsData.filter((item) =>
  //     item.clientIds.some((id) => id !== "CA00246" && id !== "XP15732")
  //   );

  //   setDpkPositions(newDpkPosition);
  //   setFilteredDpkPositions(newDpkPosition);

  //   setPhkPositions(newPhkPosition);
  //   setFilteredPhkPositions(newPhkPosition);

  //   setOtherAccPositions(newOtherAccPositions);
  //   setFilteredOtherAccPositions(newOtherAccPositions);
  // }, [state, filteredLivePositionsData]);


  useEffect(() => {
  console.log("Live Positions before the Data Updated", filteredLivePositionsData);
  
  const newDpkPosition = filteredLivePositionsData
    .filter((item) => item.clientIds.includes("CA00246"))
    .map((item) => ({
      ...item,
      clientIds: ["CA00246"]
    }));
    
  const newPhkPosition = filteredLivePositionsData
    .filter((item) => item.clientIds.includes("XP15732"))
    .map((item) => ({
      ...item,
      clientIds: ["XP15732"] 
    }));
    
  // const newOtherAccPositions = filteredLivePositionsData
    // .filter((item) => item.clientIds.some((id) => id !== "CA00246" && id !== "XP15732"))
    // .map((item) => ({
    //   ...item,
    //   clientIds: item.clientIds.filter((id) => id !== "CA00246" && id !== "XP15732") // Remove CA00246 and XP15732 from clientIds
    // }));

// const newOtherAccPositions = filteredLivePositionsData
//   .filter((item) => item.symbol.includes("NIFTY") && !item.symbol.includes("BANKNIFTY"))

  const newOtherAccPositions = filteredLivePositionsData
    .filter((item) => {
      const excludedClients = [];
      const allowedSymbols = ["NIFTY", "FINNIFTY", "SENSEX", "MIDCPNIFTY", "BANKNIFTY","MCX"];
      
      // Check if any clientId in the item is from excluded clients
      const hasExcludedClient = item.clientIds.some(id => excludedClients.includes(id));
      
      if (!hasExcludedClient) {
        // If no excluded clients, include all positions
        return allowedSymbols.some(symbol => item.symbol.includes(symbol));
        // return true;
      } else {
        // If has excluded clients, only include if symbol contains allowed symbols
        return allowedSymbols.some(symbol => item.symbol.includes(symbol));
      }
    })
    .map((item) => ({
      ...item,
      // Remove excluded client IDs from clientIds array
      clientIds: item.clientIds.filter(id => {
        const excludedClients = [];
        const allowedSymbols = ["NIFTY", "FINNIFTY", "SENSEX", "MIDCPNIFTY", "BANKNIFTY","MCX"];
        
        if (!excludedClients.includes(id)) {
          // Keep all other client IDs
          return allowedSymbols.some(symbol => item.symbol.includes(symbol));
          // return true;
        } else {
          // Keep excluded client IDs only if symbol contains allowed symbols
          return allowedSymbols.some(symbol => item.symbol.includes(symbol));
        }
      })
    }));

  setDpkPositions(newDpkPosition);
  setFilteredDpkPositions(newDpkPosition);

  setPhkPositions(newPhkPosition);
  setFilteredPhkPositions(newPhkPosition);

  setOtherAccPositions(newOtherAccPositions);
  setFilteredOtherAccPositions(newOtherAccPositions);
}, [state, filteredLivePositionsData]);

  // console.log("All Live Positions -------", filteredLivePositionsData);

  const totalPositionCM = filteredDpkPositions.length;
  const totalPositionDPK = filteredPhkPositions.length;
  const totalPositionOthers = filteredOtherAccPositions.length;

  const uniquePositionsCM = filteredDpkPositions.reduce((acc, current) => {
    const exists = acc.find((item) => item.symbol === current.symbol);
    if (!exists) {
      acc.push(current);
    }
    return acc;
  }, []);

  const uniquePositionsDPK = filteredPhkPositions.reduce((acc, current) => {
    const exists = acc.find((item) => item.symbol === current.symbol);
    if (!exists) {
      acc.push(current);
    }
    return acc;
  }, []);

  const uniquePositionsOthers = filteredOtherAccPositions.reduce(
    (acc, current) => {
      const exists = acc.find((item) => item.symbol === current.symbol);
      if (!exists) {
        acc.push(current);
      }
      return acc;
    },
    []
  );


  console.log("Unique Positions Othe r account chekcing noww .................\n", filteredOtherAccPositions);
  

  return (
    <>
      <div className="flex justify-between h-[40px] px-6 ">
        <div className=" flex h-[40px]  space-x-6">
          <div
            onClick={() => handleChangeTabs("cm-positions")}
            className={` ${
              livePositionTab === "cm-positions"
                ? "text-[#07F2C7]  border-[#07F2C7]"
                : "border-transparent"
            } flex items-center border-b-[4px]  text-[16px] font-semibold text-gray-400  cursor-pointer transition  duration-300 ease-in    `}
          >
            Clearmind
          </div>
          <div
            onClick={() => handleChangeTabs("phk-positions")}
            className={` ${
              livePositionTab === "phk-positions"
                ? "text-[#07F2C7]  border-[#07F2C7]"
                : "border-transparent"
            } flex items-center border-b-[4px] text-[16px] font-semibold text-gray-400  cursor-pointer transition  duration-300 ease-in  `}
          >
            PHK
          </div>
          <div
            onClick={() => handleChangeTabs("rest-positions")}
            className={` ${
              livePositionTab === "rest-positions"
                ? "text-[#07F2C7]  border-[#07F2C7]"
                : "border-transparent"
            } flex items-center border-b-[4px] text-[16px] font-semibold text-gray-400  cursor-pointer transition  duration-300 ease-in  `}
          >
            Other Accounts
          </div>

          <div
            onClick={() => handleChangeTabs("realtime-positions")}
            className={` ${
              livePositionTab === "realtime-positions"
                ? "text-[#07F2C7]  border-[#07F2C7]"
                : "border-transparent"
            } flex items-center border-b-[4px] text-[16px] font-semibold text-gray-400  cursor-pointer transition  duration-300 ease-in  `}
          >
            All Live Positions Websocket
          </div>
        </div>

        {livePositionTab === "cm-positions" && (
          <div className="flex text-white font-semibold items-center space-x-6 px-2 h-full">
            <div>
              Total Positions :
              <span className="ml-2 text-[#07F2C7] font-semibold">
                {totalPositionCM}
              </span>
            </div>

            <div>
              Total Unique Positions :
              <span className="ml-2 text-[#07F2C7] font-semibold">
                {uniquePositionsCM?.length}
              </span>
            </div>
          </div>
        )}

        {livePositionTab === "phk-positions" && (
          <div className="flex text-white font-semibold items-center space-x-6 px-2 h-full">
            <div>
              Total Positions :
              <span className="ml-2 text-[#07F2C7] font-semibold">
                {totalPositionDPK}
              </span>
            </div>

            <div>
              Total Unique Positions :
              <span className="ml-2 text-[#07F2C7] font-semibold">
                {uniquePositionsDPK?.length}
              </span>
            </div>
          </div>
        )}

        {livePositionTab === "rest-positions" && (
          <div className="flex text-white font-semibold items-center space-x-6 px-2 h-full">
            <div>
              Total Positions :
              <span className="ml-2 text-[#07F2C7] font-semibold">
                {totalPositionOthers}
              </span>
            </div>

            <div>
              Total Unique Positions :
              <span className="ml-2 text-[#07F2C7] font-semibold">
                {uniquePositionsOthers?.length}
              </span>
            </div>
          </div>
        )}

        {/* {livePositionTab === "realtime-positions" && (
          <div className="flex text-white font-semibold items-center space-x-6 px-2 h-full">
            <div>
              Total Positions :
              <span className="ml-2 text-[#07F2C7] font-semibold">
                {totalPositionOthers}
              </span>
            </div>

            <div>
              Total Unique Positions :
              <span className="ml-2 text-[#07F2C7] font-semibold">
                {uniquePositionsOthers?.length}
              </span>
            </div>
          </div>
        )} */}
      </div>

      {/* {livePositionTab === "cm-positions" && (
        <LivePositionsCM
          filteredLivePositionsData={filteredDpkPositions}
          setFilteredLivePositionsFno={setFilteredDpkPositions}
          setFilteredLivePositionsEquity={setFilteredLivePositionsEquity}
          sortOrder={sortOrder}
          setSortOrder={setSortOrder}
          currentState={currentState}
          allUser={allUser}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      )} */}

      {/* {livePositionTab === "phk-positions" && (
        <LivePositionsPHK
          filteredLivePositionsData={filteredPhkPositions}
          setFilteredLivePositionsFno={setFilteredPhkPositions}
          setFilteredLivePositionsEquity={setFilteredLivePositionsEquity}
          sortOrder={sortOrder}
          setSortOrder={setSortOrder}
          currentState={currentState}
          allUser={allUser}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      )} */}
      
      {/* {livePositionTab === "rest-positions" && (
        <LivePositionsRestAccount
          filteredLivePositionsData={filteredOtherAccPositions}
          setFilteredLivePositionsFno={setFilteredOtherAccPositions}
          setFilteredLivePositionsEquity={setFilteredLivePositionsEquity}
          sortOrder={sortOrder}
          setSortOrder={setSortOrder}
          currentState={currentState}
          allUser={allUser}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      )} */}


      {livePositionTab === "cm-positions" && (
        <NewLivePositionsCM
          filteredLivePositionsData={filteredDpkPositions}
          setFilteredLivePositionsFno={setFilteredDpkPositions}
          setFilteredLivePositionsEquity={setFilteredLivePositionsEquity}
          sortOrder={sortOrder}
          setSortOrder={setSortOrder}
          currentState={currentState}
          allUser={allUser}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      )}


      {livePositionTab === "phk-positions" && (
        <NewLivePositionsPHK
          filteredLivePositionsData={filteredPhkPositions}
          setFilteredLivePositionsFno={setFilteredPhkPositions}
          setFilteredLivePositionsEquity={setFilteredLivePositionsEquity}
          sortOrder={sortOrder}
          setSortOrder={setSortOrder}
          currentState={currentState}
          allUser={allUser}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      )}

      {livePositionTab === "rest-positions" && (
        <NewLivePositionsRestAccounts
          filteredLivePositionsData={filteredOtherAccPositions}
          setFilteredLivePositionsFno={setFilteredOtherAccPositions}
          setFilteredLivePositionsEquity={setFilteredLivePositionsEquity}
          sortOrder={sortOrder}
          setSortOrder={setSortOrder}
          currentState={currentState}
          accountName={accountName}
          allUser={allUser}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      )}

      {livePositionTab === "realtime-positions" && (
        <LivePositionsWebsocket />
      )}
    </>
  );
}
